export function deepCreate(obj1) {
    return JSON.parse(JSON.stringify(obj1));
}

export function deepCompare(obj1, obj2){
    return JSON.stringify(obj1) === JSON.stringify(obj2)

}